import { useRef, useState, type RefObject } from 'react';
import { copyToClipboard } from '@/shared/effects/copyToClipboard';

interface CopyToClipboardResult {
  isCopied: boolean;
  copy: (value: string) => void;
}

export function useCopyToClipboard(): CopyToClipboardResult {
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const feedbackTimeoutRef: RefObject<ReturnType<typeof setTimeout> | null> = useRef(null);

  const copy = (value: string): void => {
    void copyToClipboard({
      value,
      clipboard: navigator.clipboard,
      feedbackTimeoutRef,
      setIsCopied,
    });
  };

  return { isCopied, copy };
}
